// extracted by mini-css-extract-plugin
export default {"privacy-policy":"TermsAndConditions_privacy-policy__z9doo","text":"TermsAndConditions_text__mftX7"};